import {h, Component, Fragment} from 'preact';
import {sendRequest, calcCommisionBySppsService, getErrorRequestMessage} from "../../tools";
import SppsServiceRow from "./SppsServiceRow";
import SirenaContractRow from "./SirenaContractRow";

class Form extends Component {
	/**
	 * @param {{getAccountsUrl: string, getSppsDebtsUrl: string, payRulesUrl: string, createOrderUrl: string, bankCards: {id: number, pan: string, paymentSystem: string, icon: string}[], texts: {}, allowedPayment: boolean, paymentUrl: string}} props
	 */
	constructor(props){
		super(props);
		this.state = {
			account: null,
			accounts: [],
			selectedContractdIds: [], // Массив отмеченных к оплате составных id шников договоров сирены. Формат ID: accountId#contractId
			contractdIds: [], // Массив составных id шников договоров сирены. Формат ID: accountId#contractId
			selectedSppsDebt: [], // Массив отмеченных к оплате составных id шников услуг сппс. Формат ID: accountId#serviceId, где serviceId - ID услуги в СППС
			customAmounts: {}, // Объект произвольных сумм по услугам, введённых пользователем. Формат ключа accountId_serviceId, где serviceId - ID услуги в СППС
			bankCardId: props.bankCards.length ? props.bankCards[0].id:null,
			details: props.details,
			devices: props.devices,
		};
		// В стейте еще предполагаются данные с динамическими ключами
		// Form.getKeySppsDebtsState(accountId)
		// Form.getKeySppsDebtsIsOpenState(accountId)
		// Form.getKeySppsDebtsIsLoadedState(accountId)

		this.inititalLoaded = false;

		window.debtsFormRefresh = () => this.refresh();
	}

	componentDidMount(){
		this.fetchAccounts();
	}

	render(props, state, context){
		const {accounts} = state;
		var {details, devices} = state;
		if(accounts.length <= 0) return;
		return (
			<Fragment>
				<div className="row">
					<div className="col col-12">
						{accounts.map((account) => {
							if (account.id == props.accountId) {

								const {contracts} = account;
								const sppsDebtsIsOpen = !!state[Form.getKeySppsDebtsIsOpenState(account.id)];
								const sppsDebtsIsLoaded = !!state[Form.getKeySppsDebtsIsLoadedState(account.id)];
								const sppsDebts = state[Form.getKeySppsDebtsState(account.id)];
								return (
									<Fragment>
										{!!contracts && contracts.length > 0 && (
											contracts.map(contract => (
												<section className="debt-table main__section js__toggle-block contract">
													<div className="debt-table__header">
														<div className="debt-table__header-contract">
															<div className="debt-table__titles">
																<div
																	className="debt-table__title-1-details">{account.address}</div>
																<div
																	className="debt-table__title-2-details">ЛС {account.id}</div>
															</div>
														</div>
													</div>
													<div className="debt-table__body sirena-contract">
														<SirenaContractRow
															contract={contract}
															account={account}
															isChecked={props.allowedPayment && this.isSelectedSirenaContract(account.id, contract.id)}
															onChangeCheckbox={this.onChangeSirenaContractCheckbox}
															formParams={props}
															amounts={this.getSirenaContractAmounts(contract)}
															onChangeAmountInput={this.onChangeAmountInput.bind(this)}
															createOrderForContract={this.createOrderForContract.bind(this)}
															details={details}
															devices={devices}
														/>
													</div>
													{
														!!props.allowedPayment && <Fragment>
															{sppsDebtsIsOpen && (
																<div className="debt-table__body has-scrollbar">
																	{sppsDebts && sppsDebts.length ? sppsDebts.map((debt => (
																		<SppsServiceRow
																			debt={debt}
																			account={account}
																			isChecked={this.isSelectedSppsService(account.id, debt.serviceId, debt.accountId)}
																			onChangeCheckbox={this.onChangeSppsServiceCheckbox}
																			isCheckedPlanAccruals={this.isSelectedSppsService(account.id, debt.serviceId, debt.accountId, 1)}
																			formParams={props}
																			amounts={this.getSppsServiceAmounts(debt)}
																			onChangeAmountInput={this.onChangeAmountInput.bind(this)}
																		/>
																	))) : (
																		<div
																			className="debt-table-item-2 debt-table__item">
																			<div className="debt-table-item__row">
																				<div className="debt-table-item-2__col">
																				</div>
																				<div
																					className="debt-table-item-2__col debt-table-item-2__col_fg_1">
																					<div
																						className="debt-table-item-2__text">
																						Задолженность по другим
																						поставщикам не найдена
																					</div>
																				</div>
																			</div>
																		</div>
																	)}
																</div>
															)}
														</Fragment>
													}
												</section>
											))
										)}
									</Fragment>
								);
							}
						})}
						<div className="buttons-row">
							<div className="col-lg-12">
								<a className="button button-secondary button-secondary_arrow_back" href="/">Назад к списку адресов</a>
							</div>
						</div>
					</div>
				</div>
			</Fragment>



		)
	}

	fetchAccounts(){
		sendRequest(this.props.getAccountsUrl, {
			showLoader: !this.inititalLoaded
		}).then(response => {
			switch(response.status)
			{
				case 200:
					this.setState({accounts: response.data.items});
					if(this.inititalLoaded === false)
					{
						const selectedContractdIds = [];
						const contractdIds = [];

						response.data.items.forEach(account => {
							if(account.id == this.props.accountId) {
								this.setState({account: account});
								const {contracts} = account;
								if(contracts && contracts.length > 0)
								{
									contracts.forEach(contract => {
										if(contract.totalAmount > 0)
										{
											selectedContractdIds.push(this.getKeyAmountInput(account.id, contract.id));
											contractdIds.push({accountId: account.id, contractId: contract.id});
										}
									})
								}
							}
						});

						this.setState({selectedContractdIds, contractdIds});
					}

					this.inititalLoaded = true;
					break;

				default:
					throw new Error(`Status ${response.status}. Status text: ${response.statusText}`);
			}
		}).catch(error => Form.showRequestError(error));
	}

	fetchSppsDebts(accountId){
		sendRequest(this.props.getSppsDebtsUrl, {
			body: {accountId: accountId},
			showLoader: true
		}).then(response => {
			switch(response.status)
			{
				case 200:
					const data = {};
					data[Form.getKeySppsDebtsState(accountId)] = response.data.items ? response.data.items:[];
					data[Form.getKeySppsDebtsIsOpenState(accountId)] = true;
					data[Form.getKeySppsDebtsIsLoadedState(accountId)] = true;
					this.setState(data);
					break;

				default:
					throw new Error(`Status ${response.status}. Status text: ${response.statusText}`);
			}
		}).catch(error => Form.showRequestError(error));
	}

	refresh(){
		this.fetchAccounts();
	}

	createOrder(){
		const self = this;
		const {selectedContractdIds, selectedSppsServicesIds, accounts, selectedSppsDebt,} = this.state;
		const props = this.props;

		const data = {
			items: [],
			bankCardId: this.state.bankCardId
		};

		if(selectedContractdIds.length > 0)
		{
			window.reachGoal('oplata');
			selectedContractdIds.forEach(compositeId => {
				const [accountId, contractId] = compositeId.split('#').map(id => id);
				const account = accounts.find(item => item.id === accountId);
				if(account)
				{
					const {contracts} = account;
					const contract = !!contracts && contracts.find(item => item.id === contractId);
					if(contract)
					{
						const contractAmounts = this.getSirenaContractAmounts(contract);
						if(contractAmounts.debt > 0 || contractAmounts.fine > 0)
						{
							data.items.push({
								accountId,
								contractId,
								type: 'sirena_contract',
								amount: contractAmounts.debt,
								fineAmount: contractAmounts.fine,
							});
						}
					}
				}
			});
		}

		if(selectedSppsDebt.length > 0)
		{
			const addDataItem = function(accountId, sppsServiceId, amount, debtAccountId) {
				data.items.push({accountId, sppsServiceId, type: 'spps_service', amount, debtAccountId});
			};

			selectedSppsDebt.forEach(sppsService => {
				const {accountId, serviceId, debtAccountId, isPlan} = sppsService;
				const debts = this.state[Form.getKeySppsDebtsState(accountId)];
				const debt = !!debts && debts.find(item => item.accountId === debtAccountId && item.serviceId === + serviceId);

				if(debt)
				{
					const debtAmounts = self.getSppsServiceAmounts(debt);

					if(debtAmounts.debt > 0 || debtAmounts.plan)
					{
						let amount = 0;

						if(isPlan === 0)
						{
							amount += Math.max(0, parseFloat(debtAmounts.debt) || 0);

							if(this.isSelectedSppsService(accountId, serviceId, debtAccountId, 1))
							{
								amount += Math.max(0, parseFloat(debtAmounts.plan) || 0);
							}
						}
						else if(!this.isSelectedSppsService(accountId, serviceId, debtAccountId))
						{
							amount += Math.max(0, parseFloat(debtAmounts.plan) || 0);
						}

						if(amount > 0)
						{
							addDataItem(accountId, debt.serviceId, amount, debtAccountId);
						}
					}


					if(debt.fineServiceId && debtAmounts.fine > 0)
					{
						addDataItem(accountId, debt.fineServiceId, debtAmounts.fine, debtAccountId);
					}
				}
			});
		}

		if(!data.items.length)
		{
			$.disMsg('Выберите услуги для оплаты', {type: 'false'});
			return false;
		}

		sendRequest(this.props.createOrderUrl, {
			body: data,
			type: 'POST',
			showLoader: true
		}).then(response => {
			switch(response.status)
			{
				case 200:
					const order = response.data;
					if(order.id)
					{
						if(window.ajaxIndicatior) window.ajaxIndicatior.show();
						window.location = order.paymentUrl;
					}
					else throw new Error(`Status 200. Status text: Ошибка создания заказа`);
					break;

				default:
					throw new Error(`Status ${response.status}. Status text: ${response.statusText}`);
			}
		}).catch(error => Form.showRequestError(error));
	}

	createOrderForContract(accountId, contractId){
		const self = this;
		const {selectedContractdIds, selectedSppsServicesIds, accounts, selectedSppsDebt} = this.state;
		const props = this.props;

		const data = {
			items: [],
			bankCardId: this.state.bankCardId
		};

		const account = accounts.find(item => item.id === accountId);
		if(account)
		{
			const {contracts} = account;
			const contract = !!contracts && contracts.find(item => item.id === contractId);
			if(contract)
			{
				const contractAmounts = this.getSirenaContractAmounts(contract);
				if(contractAmounts.debt > 0 || contractAmounts.fine > 0)
				{
					data.items.push({
						accountId,
						contractId,
						type: 'sirena_contract',
						amount: contractAmounts.debt,
						fineAmount: contractAmounts.fine,
					});
				}
			}
		}


		if(!data.items.length)
		{
			$.disMsg('Выберите услуги для оплаты', {type: 'false'});
			return false;
		}
		sendRequest(this.props.createOrderUrl, {
			body: data,
			type: 'POST',
			showLoader: true
		}).then(response => {
			switch(response.status)
			{
				case 200:
					const order = response.data;
					if(order.id)
					{
						if(window.ajaxIndicatior) window.ajaxIndicatior.show();
						window.location = order.paymentUrl;
					}
					else throw new Error(`Status 200. Status text: Ошибка создания заказа`);
					break;

				default:
					throw new Error(`Status ${response.status}. Status text: ${response.statusText}`);
			}
		}).catch(error => Form.showRequestError(error));
	}

	isSelectedSirenaContract = (accountId, contractId) => {
		let p = this.state.selectedContractdIds.indexOf(this.getKeyAmountInput(accountId, contractId));
		return this.state.selectedContractdIds.indexOf(this.getKeyAmountInput(accountId, contractId)) !== -1;
	};

	isSelectedSirenaContractMultiple = (accountId, contracts) => {
		contracts.map(contract => {
			if(this.state.selectedContractdIds.indexOf(this.getKeyAmountInput(accountId, contract.id)) == -1) {
				return false;
			}
		});
		return true;
	};

	onChangeAccountCheckbox = (accountId, contracts) => (e) => {
		e.preventDefault();
		let selectedContractdIds = this.state.selectedContractdIds.slice();
		contracts.map(contract => {
			let compositeId = this.getKeyAmountInput(accountId, contract.id);
			let index = selectedContractdIds.indexOf(compositeId);
			if(index !== -1) {
				selectedContractdIds.splice(index, 1);
			} else {
				selectedContractdIds.push(compositeId);
			}
		});
		this.setState({selectedContractdIds});
	};

	onChangeSelectAllCheckbox = () => e => {
		e.preventDefault();
		let selectedContractdIds = [];
		if(e.target.checked) {
			selectedContractdIds = this.state.selectedContractdIds.slice();
			this.state.contractdIds.map(item => {
				const compositeId = this.getKeyAmountInput(item.accountId, item.contractId);
				const index = selectedContractdIds.indexOf(compositeId);
				if(index == -1) {
					selectedContractdIds.push(compositeId);
				}
			});
		}
		this.setState({selectedContractdIds: selectedContractdIds});
	}

	ifAllChecked = () => {
		let selectedContractdIds = this.state.selectedContractdIds.slice();
		let result = true;
		this.state.contractdIds.map(item => {
			const compositeId = this.getKeyAmountInput(item.accountId, item.contractId);
			const index = selectedContractdIds.indexOf(compositeId);
			if(index == -1) {
				result = false;
			}
		});
		return result;
	}

	onChangeSirenaContractCheckbox = (accountId, contractId) => (e) => {
		e.preventDefault();
		let selectedContractdIds = this.state.selectedContractdIds.slice();
		const compositeId = this.getKeyAmountInput(accountId, contractId);
		const index = selectedContractdIds.indexOf(compositeId);

		if(index !== -1) selectedContractdIds.splice(index, 1);
		else selectedContractdIds.push(compositeId);
		this.setState({selectedContractdIds});
	};

	isSelectedSppsService = (accountId, serviceId, debtAccountId, isPlan = 0) => {
		return this.state.selectedSppsDebt.findIndex((debt) => debt.serviceId === serviceId && debt.debtAccountId === debtAccountId && debt.accountId === accountId && debt.isPlan === isPlan) !== -1;
	};

	onChangeSppsServiceCheckbox = (accountId, serviceId, debtAccountId, isPlan = 0) => (e) => {
		e.preventDefault();
		const selectedSppsDebtKey = this.state.selectedSppsDebt.findIndex((debt) => debt.serviceId === serviceId && debt.debtAccountId === debtAccountId && debt.accountId === accountId && debt.isPlan === isPlan);

		this.setState({
			selectedSppsDebt: selectedSppsDebtKey !== -1
				? this.state.selectedSppsDebt.filter((debt) => !(debt.serviceId === serviceId && debt.debtAccountId === debtAccountId && debt.accountId === accountId && debt.isPlan === isPlan))
				:[...this.state.selectedSppsDebt, {accountId, serviceId, debtAccountId, isPlan}]

		});
	};

	getSirenaContractAmounts(contract){
		const {customAmounts} = this.state;

		const amounts = {
			debt: contract.debtAmount,
			fine: contract.fineAmount,
			comission: 0,
			total: 0,
		};

		if(this.isSelectedSirenaContract(contract.accountId, contract.id))
		{
			if(contract.sppsServiceDebtInfo)
			{
				const customDebtAmount = customAmounts[this.getKeyAmountInput(contract.accountId, contract.sppsServiceDebtInfo.id)];
				if(customDebtAmount !== undefined)
				{
					amounts.debt = customDebtAmount;
				}
				else amounts.debt = Math.max(0, amounts.debt);
			}

			if(contract.sppsServiceFineInfo)
			{
				const customFineAmount = customAmounts[this.getKeyAmountInput(contract.accountId, contract.sppsServiceFineInfo.id)];
				if(customFineAmount !== undefined)
				{
					amounts.fine = customFineAmount;
				}
				else amounts.fine = Math.max(0, amounts.fine);
			}
		}

		if(contract.sppsServiceDebtInfo)
		{
			amounts.comission += calcCommisionBySppsService(parseFloat(amounts.debt) || 0, contract.sppsServiceDebtInfo);
		}

		if(contract.sppsServiceFineInfo)
		{
			amounts.comission += calcCommisionBySppsService(parseFloat(amounts.fine) || 0, contract.sppsServiceFineInfo);
		}

		amounts.total = Math.max(0, parseFloat(amounts.debt) || 0) + Math.max(0, parseFloat(amounts.fine) || 0) + amounts.comission;

		return amounts;
	}

	getSppsServiceAmounts(debt){
		const {customAmounts} = this.state;

		const amounts = {
			debt: debt.debtAmount,
			fine: debt.fineAmount,
			plan: debt.planAccruals || 0,
			planComission: 0,
			comission: 0,
			total: 0,
		};


		const isSelectedSppsService = this.isSelectedSppsService(debt.sirenaAccountId, debt.serviceId, debt.accountId);
		const isSelectedSppsPlanAccrualsService = this.isSelectedSppsService(debt.sirenaAccountId, debt.serviceId, debt.accountId, 1);

		if(isSelectedSppsService)
		{
			if(debt.debtServiceInfo)
			{
				const customDebtAmount = customAmounts[this.getKeyAmountInput(debt.sirenaAccountId, debt.serviceId, debt.accountId)];
				if(customDebtAmount !== undefined)
				{
					amounts.debt = customDebtAmount;
				}
				else amounts.debt = Math.max(0, amounts.debt);
			}

			if(debt.fineServiceId && debt.fineServiceInfo)
			{
				const customFineAmount = customAmounts[this.getKeyAmountInput(debt.sirenaAccountId, debt.fineServiceId + '_' + debt.serviceId, debt.accountId)];
				if(customFineAmount !== undefined)
				{
					amounts.fine = customFineAmount;
				}
				else amounts.fine = Math.max(0, amounts.fine);
			}
		}
		if(isSelectedSppsPlanAccrualsService)
		{
			if(debt.debtServiceInfo)
			{
				const customPlanAmount = customAmounts[this.getKeyAmountInput(debt.sirenaAccountId, debt.serviceId, debt.accountId, 1)];
				if(customPlanAmount !== undefined)
				{
					amounts.plan = customPlanAmount;
				}
				else amounts.plan = Math.max(0, amounts.plan);
			}
		}

		if(debt.debtServiceInfo)
		{
			amounts.comission += calcCommisionBySppsService(parseFloat(amounts.debt) || 0, debt.debtServiceInfo);
			amounts.planComission += calcCommisionBySppsService(parseFloat(amounts.plan) || 0, debt.debtServiceInfo);
		}

		if(debt.fineServiceId && debt.fineServiceInfo)
		{
			amounts.comission += calcCommisionBySppsService(parseFloat(amounts.fine) || 0, debt.fineServiceInfo);
		}

		amounts.total =
			(!isSelectedSppsPlanAccrualsService  || isSelectedSppsService ? Math.max(0, parseFloat(amounts.debt) || 0) : 0)
			+ (!isSelectedSppsPlanAccrualsService  || isSelectedSppsService ? Math.max(0, parseFloat(amounts.fine) || 0) : 0)
			+ (isSelectedSppsPlanAccrualsService ? Math.max(0, parseFloat(amounts.plan) || 0) : 0)
			+ (!isSelectedSppsPlanAccrualsService  || isSelectedSppsService ? amounts.comission : 0)
			+ (isSelectedSppsPlanAccrualsService ? amounts.planComission : 0)
		;

		return amounts;
	}

	calcAmount(){
		const {selectedContractdIds, selectedSppsDebt, accounts} = this.state;
		let amount = 0;

		selectedContractdIds.forEach(compositeId => {
			const [accountId, contractId] = compositeId.split('#').map(id => id);
			const account = accounts.find(item => item.id === accountId);
			if(account)
			{
				const {contracts} = account;
				const contract = !!contracts && contracts.find(item => item.id === contractId);
				if(contract)
				{
					const contractAmounts = this.getSirenaContractAmounts(contract);
					amount += contractAmounts.total;
				}
			}
		});

		selectedSppsDebt.forEach(sppsService => {
			const {accountId, serviceId, debtAccountId, isPlan} = sppsService;
			const account = accounts.find(item => item.id === accountId);
			if(account)
			{
				const debts = this.state[Form.getKeySppsDebtsState(accountId)];
				const debt = !!debts && debts.find(item => item.accountId === debtAccountId && item.serviceId === + serviceId);
				if(debt)
				{
					if (isPlan === 0 || !this.isSelectedSppsService(accountId, serviceId, debtAccountId))
					{
						const debtAmounts = this.getSppsServiceAmounts(debt);
						amount += debtAmounts.total;
					}
				}
			}
		});

		return amount;
	}

	onChangeBankCard = id => (e) => {
		e.preventDefault();
		this.setState({bankCardId: id});
	};

	onClickShowSppsDebts = (accountId) => (e) => {
		const debtsIsLoaded = !!this.state[Form.getKeySppsDebtsIsLoadedState(accountId)];
		const debtsIsOpen = !!this.state[Form.getKeySppsDebtsIsOpenState(accountId)];
		if(debtsIsLoaded)
		{
			const data = {};
			data[Form.getKeySppsDebtsIsOpenState(accountId)] = !debtsIsOpen;
			this.setState(data);
		}
		else this.fetchSppsDebts(accountId);
	};

	onClickCreateOrder = (e) => {
		this.createOrder();
	};

	onChangeAmountInput = (accountId, serviceId, max = 0, debtAccountId = undefined, isPlan = 0) => e => {
		const customAmounts = {...this.state.customAmounts};
		let key = this.getKeyAmountInput(accountId, serviceId, debtAccountId, isPlan);

		let value = e.target.value.replace(/[^\d\\.,]/g, '').replace(/,/g, '.');

		// Фильтруем 2 точки в строке
		if(/^.*\..*\.$/.test(value))
		{
			value = value.substr(0, value.length - 1);
		}

		if(max > 0 && value > max) value = max;
		customAmounts[key] = value;

		this.setState({customAmounts});
	};

	getKeyAmountInput(accountId, serviceId, debtAccountId = undefined, isPlan = 0)
	{
		let key = accountId + '#' + serviceId;

		if(typeof debtAccountId !== "undefined")
		{
			key += '#' + debtAccountId;
		}
		if(isPlan !== 0)
		{
			key += '#' + isPlan;
		}

		return key;
	}

	static getKeySppsDebtsState(accountId){
		return 'sppsDebts_' + accountId;
	}

	static getKeySppsDebtsIsOpenState(accountId){
		return 'sppsDebtsIsOpen_' + accountId;
	}

	static getKeySppsDebtsIsLoadedState(accountId){
		return 'sppsDebtsIsLoaded_' + accountId;
	}

	static showRequestError(error){
		$.disMsg(getErrorRequestMessage(error), {type: 'false'});
	}
}

export default Form;
